import { render, staticRenderFns } from "./parkininfo.vue?vue&type=template&id=3527510c&scoped=true"
import script from "./parkininfo.vue?vue&type=script&lang=js"
export * from "./parkininfo.vue?vue&type=script&lang=js"
import style0 from "./parkininfo.vue?vue&type=style&index=0&id=3527510c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3527510c",
  null
  
)

export default component.exports